import { generateParams } from "utils/urlConversion";
import { api } from "services/api";
import { SelectImageParams, UpsertImageRequest } from "./typing";

import { transformImageResult } from "./imageTransformers";
import { TaggedImage, TaggedImageResult } from "constructs/TaggedImage";

const imageApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getImages: builder.query<Array<TaggedImage>, SelectImageParams>({
      query: (params) => {
        let url = `/image`;
        
        if (params.id) {
          // Use the params.id to get the image if its provided
          url = `${url}/${params.id}`;
        } 
        return url + generateParams(params);
      },
      transformResponse: (result: Array<TaggedImageResult>, meta, args) => {
        return transformImageResult(result);
      }
    }),


    addImage: builder.mutation<any, UpsertImageRequest>({
      query: (imageData) => {
        let bodyFormData = new FormData();
        
        if (imageData.image?.length) {
          bodyFormData.append("image", imageData.image[0], imageData.name);
        }

        // Remove image from the imageDetails regardless of whether it was undefined or not 
        delete imageData["image"];

        const json = JSON.stringify(imageData);
        bodyFormData.append(
          "imageDetails",
          new Blob([json], {
            type: "application/json",
          }),
          "imageDetails"
        );

        return {
          url: `/image/create`,
          method: "POST",
          // headers: {
          //   "Content-Type": "multipart/form-data;",
          // },
          body: bodyFormData,
          formData: true,
        };
      },
    }),
  }),
});

export const { 
  useGetImagesQuery,
  useLazyGetImagesQuery,

  useAddImageMutation
} = imageApi;
